import {useState, useEffect} from 'react';
import {isMobile} from "react-device-detect";
import QRCode from "react-qr-code";
import dayjs from 'dayjs';

import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
// import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import TelegramIcon from '@mui/icons-material/Telegram';
import CloseIcon from '@mui/icons-material/Close';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PeopleIcon from '@mui/icons-material/People';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import HowToRegIcon from '@mui/icons-material/HowToReg';

import {isAdmin, isAuthor} from 'ultra/helpers/auth';
import {DEFAULT_CITY} from 'ultra/const/general';
import {EVENT_TICKET_ACTIONS} from 'ultra/const/events';
import {getClientCity, getUrl, getEnvConfig, getClientConfig} from 'ultra/configs/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {getTime, getTimezoneNameString, timestampToDate, getFormatedTime} from 'ultra/helpers/date'
import {isEmptyObj} from 'ultra/helpers/utils';

import {useBackdropPreloaderStore} from '../../../../../../../../Stores/backdropPreloader';
import {useConfigStore} from '../../../../../../../../Stores/config';
import {useNavigationStore} from '../../../../../../../../Stores/navigation';
import {useNotifyStore} from '../../../../../../../../Stores/notify';
import {useToasterStore} from '../../../../../../../../Stores/toster';

import {USER_ACTIONS} from '../../../../../../../Profile/Reducers/user';
import {NODE_ACTIONS} from '../../../../../../../Content/Reducers/node';

import PreloaderTopPagePicture from '../../../../../../../../Components/Preloaders/PreloaderTopPagePicture';
import PreloaderText from '../../../../../../../../Components/Preloaders/PreloaderText';
import AdaptiveDialog from '../../../../../../../../Components/Adaptive/Dialog';
import FormContainer from '../../../../../../../../Components/Form/FormContainer';
import Icon from '../../../../../../../../Components/Icon';

import {getTelegramUser, getTelegramUserId} from '../../../../../../../../Helpers/telegram';
import {useGlobalCustomContext} from '../../../../../../../../Helpers/context';
import {startRaffle, getGuestList, registerGuest, unregisterGuest, removeGuest} from '../../../../../../../../Helpers/event';
import {makeUrlsClickable} from '../../../../../../../../Helpers/format';

import DateValue from '../../../../../../Widgets/DateValue';
import TextZoomImage from '../../../../../../Widgets/TextZoomImage';
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import TitleWidget from '../../../../../../Widgets/Title'
// import AddToCalendar from '../../../../../../Widgets/AddToCalendar'
import TopPagePicture from '../../../../../../Widgets/TopPagePicture'
import FilterChip from '../../../../../../Widgets/FilterChip'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import LocationWidget from '../../../../../../Widgets/LocationWidget'
import DefaultImage from '../../../../../../Widgets/DefaultImage';

import './index.scss'

function EventActions() {
    // props
    // const {content} = props;

    // const onAction = (action) => {
    //     console.log(action)
    // }

    return <div>
        {/* {content.place && <div className='Actions'>
            <AddToCalendar
                title={content.title}
                date={content.date}
                duration={content.duration}
                // details=''
                location={content.place}
            />
        </div>} */}
        {/* <div className='actions'>
            <Button
                size="small"
                onClick={() => onAction('interested')}
                startIcon={<StarBorderOutlinedIcon />}
                variant="outlined"
                >
                <span>Зацікавлений</span>
            </Button>

            <Button
                size="small"
                onClick={() => onAction('interested')}
                startIcon={<CheckCircleOutlineOutlinedIcon />}
                variant="outlined"
            >
                <span>Прийду</span>
            </Button>
        </div> */}
    </div>
}

function EventDetails(props) {
    const {content, meta, form} = props;

    const [days, setDays] = useState();

    const {configs} = useConfigStore();
    const [timeZone, setTimeZone] = useState();

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    useEffect(() => {
        const start = getTime(timestampToDate(content.date), timeZone);
        const end = start.add(content.duration, 'hour').subtract(1, 'second');

        if (start.date() !== end.date()) {
            setDays(1 + end.date() - start.date());
        } else {
            setDays(1);
        }
    }, [])

    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return <div>
        <RegInfo meta={meta} content={content} />

        <div className='dateDetails'>
            <span className='date labelWrap'>
                <span className="label">Дата та час:</span>
                <span className='labelValue'>
                    {getFormatedTime(timestampToDate(content.date), timeZone)}
                </span>
            </span>

            <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={getTimezoneNameString(timestampToDate(content.date), timeZone)}
                placement="top"
            >
                <IconButton size='small' className='timezoneDetails'>
                    <InfoOutlinedIcon onClick={handleTooltipOpen} />
                </IconButton>
            </Tooltip>
            </ClickAwayListener>
        </div>

        {days > 1 && <div className='eventDays'>Тривалість: {days} {days > 4 ? 'днів' : 'дні'}</div>}
        <div className="eventLabels labels labelsWrap">
            <FilterChip value={content?.region} config={form?.fields?.region} />
            <FilterChip value={content?.type} config={form?.fields?.type} />
            {/* <FilterChip value={content?.payment} config={form?.fields?.payment} /> */}
        </div>

        <LinkInfo content={content} />

        {meta?.chat && <div className='chatButton'>
            <Button
                    fullWidth
                    target="_blank"
                    // startIcon={<Icon icon={meta.chat.icon} />}
                    startIcon={<TelegramIcon />}
                    variant="outlined"
                    href={meta.chat.link}
                >
                Чат «{meta.chat.title}»
            </Button>
        </div>}

        <EventActions content={content} />
    </div>
}

export default function Template(props) {
    const {content, meta, permits, config, form, breadcrumbs} = props

    const {contentLoading} = useNavigationStore() // {contentLoading: true}; 

    let showLocation = true;

    if (content.qr_code_entrance && content.payment === 'paid') {
        if (meta?.tickets?.order?.length > 0) {
            showLocation = true;
        }
        else {
            showLocation = false;
        }
    }

    if (content.hide_location && !meta?.tickets?.order?.length) {
        showLocation = false;
    }

    if (contentLoading) return <>
        <PreloaderTopPagePicture />
        <PreloaderText />
    </>

    return <div className="Event">
        {content.banner && <TopPagePicture cutHeightForDesktop image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>}
        {!content.banner && content.poster && <TopPagePicture cutHeightForDesktop image={content.poster} hidden={config?.templateOptions?.topPagePictureHidden}/>}
        {/* showSkeleton={contentLoading}  */}
        
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle}/>
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {/* {isMobile && contentLoading && <Skeleton variant="rectangular" width="100%" height={60} style={{marginBottom: '1rem'}} />} */}
        {/* {isMobile && <EventDetails content={content}  meta={meta} form={form} />}  !contentLoading &&  */}
        
        <Grid container spacing={4}>
            {isMobile && <Grid item xs={12} md={8}>
                <div className='EventDetailsMobile'><EventDetails content={content} meta={meta} form={form} /></div>
            </Grid>}

            <Grid item xs={12} md={8}>
                <CKEditorContent
                    showSkeleton={contentLoading}
                    content={content.description}
                />
            </Grid>

            {!isMobile && <>
                <Grid item xs={12} md={4}>
                    {/* {!isMobile && contentLoading && <div className='EventDetailsDesktop'><Skeleton variant="rectangular" width="100%" height={60} style={{marginBottom: '1rem'}} /></div>} */}
                    {/* !contentLoading &&  */}
                    <div className='EventDetailsDesktop'><EventDetails content={content}  meta={meta} form={form} /></div>

                    {/* {contentLoading && <Skeleton variant="rectangular" width="100%" height={200} />} */}
                    {/* {!contentLoading &&  */}
                    {/* } */}

                    {/* {!isMobile && content.place && <LocationWidget showSkeleton={contentLoading} location={content.place} />} */}

                    {/* !contentLoading &&  */}
                    {/* {!isMobile && <div className='DesktopEmptyBlock'></div>} */}
                </Grid>

                <EventAdminActions content={content} meta={meta} />
            </>}

            {content.place && showLocation && <Grid item xs={12}>
                {content?.place?.link && <p><a href={content?.place?.link}>{content?.place?.title}</a></p>}

                <LocationWidget showSkeleton={contentLoading} location={content.place} />
            </Grid>}

            {isMobile && <EventAdminActions content={content} meta={meta} />}
        </Grid>
    </div>
}

function LinkInfo(props) {
    const {content} = props

    if (content.link)  {
        return <div className='Link'><Button
                fullWidth
                href={content.link.link}
                target="_blank"
                startIcon={<OpenInNewIcon />}
                variant="outlined"
            >
            {content.link.title}
        </Button></div>
    }

    return <></>
}

function RegInfo(props) {
    const {meta, content} = props

    const {api} = getClientConfig(window)
    const {configs} = useConfigStore()
    const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()

    const [timeZone, setTimeZone] = useState()
    const [eventInPast, setIventInPast] = useState(false)
    const [ticketInfo, setTicketInfo] = useState({})
    const [paymentOpen, setPaymentOpen] = useState(false)
    const [eventBuyTicketConfig, setEventBuyTicketConfig] = useState({})

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    useEffect(() => {
        if (content.date) setIventInPast(dayjs().isAfter(dayjs(timestampToDate(content.date)).add(content.duration, 'hour')))

        {/* INFO: це тимчасове рішення, можливо треба буде видалити. Для купівлі квитків на подію треба використовувати корзину */}
        const config = {
            fields: {
                guests: {
                    type: "filter",
                    placeholder: "Кількість гостей",
                    required: true,
                    values: {
                        values: {
                            "1": "1",
                            "2": "2",
                            "3": "3",
                            "4": "4",
                            "5": "5",
                            "6": "6",
                            "7": "7",
                            "8": "8"
                        },
                    }
                },
                screenshot: {
                    visible: {
                        guests: "not-empty-field"
                    },
                    required: true,
                    placeholder: "Скріншот про сплату",
                    type: "image"
                },
                notes: {
                    type: "text",
                    placeholder: "Коментар або питання",
                    visible: {
                        guests: "not-empty-field"
                    },
                }
            },
            fieldsOrder: [
                "guests",
                "paymentSubtitle",
                "payment",
                "screenshot",
                "notes"
            ],
            form: {
                submitText: "Зареєструватись",
                endpoint: `${api}/bot/prostir/node/event/${city}/${content._did}/tickets/registration/ticket/0`,
                successMessage: "Дякуємо за реєстрацію! До зустрічі на події"
            }
        }

        if (content?.priceAndPayments) {
            const payment = {
                visible: {
                    guests: "not-empty-field"
                },
                required: true,
                placeholder: "Методи оплати",
                type: "partnerPayments",
                config: [],
                options: {
                    priceAmountField: "guests"
                }
            }

            if (content?.priceAndPayments?.pre) payment.options.pricePre = content.priceAndPayments.pre;
            if (content?.priceAndPayments?.sufix) payment.options.priceSufix = content.priceAndPayments.sufix;
            if (content?.priceAndPayments?.notes1) payment.options.priceNotes1 = content.priceAndPayments.notes1;
            if (content?.priceAndPayments?.notes2) payment.options.priceNotes2 = content.priceAndPayments.notes2;
            if (content?.priceAndPayments?.discounts) payment.options.discounts = content.priceAndPayments.discounts;

            content?.priceAndPayments?.values?.map(i => {
                console.log(i)
                if (i.default) payment.default = i.type
            })
            if (!payment?.default) payment.default = content?.priceAndPayments?.values?.[0]?.type

            content?.priceAndPayments?.values?.map(i => {
                const option = {
                    id: i.type,
                    label: getLabel(i.type),
                    price: i.price,
                    currency: getCurrency(i.type),
                }

                if (i.type === "mono-link") {
                    option.link = i.details
                    option.linkLabel = "Перейти до банки ↗️"
                }
                else option.value = i.details

                payment.config.push(option)
            })

            config.fields.payment = payment;

            config.fields.promocode = {
                visible: {
                    guests: "not-empty-field"
                },
                placeholder: "Промокод для знижки",
                type: "text",
            };
            
            config.fieldsOrder = [
                "guests",
                "paymentSubtitle",
                "promocode",
                "payment",
                "screenshot",
                "notes"
            ]
        }

        setEventBuyTicketConfig(config)
    }, [content])

    const {userState, userDispatch, nodeDispatch} = useGlobalCustomContext();

    const {showNotify} = useNotifyStore();

    const city = getClientCity(window) || DEFAULT_CITY;

    const closePaymentPopup = () => {
        setPaymentOpen(false)
    }

    const openPaymentPopup = () => {
        setPaymentOpen(true)
    }

    const getCurrency = (key) => {
        let result
        switch (key) {
            case "ua-card":
                result = "UAH";
                break;
            case "usdt-trc20":
                result = "USDT";
                break;
            case "mono-link":
                result = "UAH";
                break;
            case "indo-card":
                result = "IDR";
                break;
        }
        return result
    }

    const getLabel = (key) => {
        let result
        switch (key) {
            case "ua-card":
                result = "💳 Переказ на українську картку";
                break;
            case "usdt-trc20":
                result = "🔐 USDT TRC20";
                break;
            case "mono-link":
                result = "🫙 Монобанка";
                break;
            case "indo-card":
                result = "🇮🇩 Permata";
                break;
        }
        return result
    }

    const showTicket = (ticket) => {
        const i = {...ticketInfo}
        i[ticket] = !ticketInfo[ticket]
        setTicketInfo(i)
    }

    // const onBuyTicketFormChange = (e) => {
    //     console.log(e.newForm)
    //     setPaymentForm(e.newForm);
    // }

    // let tid
    // if (userState?.user?.telegram_id) {
    //     tid = userState.user.telegram_id
    // }
    // else if (getTelegramUserId()){
    //     tid = getTelegramUserId()
    // }

    // const telegram_user = <a href="">@{"username"}</a>
    // const prostir_user = <a href="">{userState?.user?.displayName}</a>

    const onUnRegClick = (did, ticket) => {
        showBackdropPreloader()
        // if (getTelegramUserId()) {
        //     const city = getClientCity(window) || DEFAULT_CITY;
        //     const app = window?.Telegram?.WebApp;
        //     if (app) app.close();
        //     window.open(`https://t.me/MiyProstirBot?start=event-reg-${city}-${content._did}`)
        // }
        // else {
        //     if (userState?.user && !isEmptyObj(userState.user)) {
                unregisterGuest(city, did, ticket)
                    .then(() => {
                        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START})
                    })
        //     }
        //     else {
        //         showPromt({
        //             snackbarMessage: 'Щоб зареєструватись, вам необхідно увійти в систему',
        //             onApproveHandler: () => {
        //                 closeToaster();
        //                 hideBackdropPreloader();

        //                 userDispatch({type: USER_ACTIONS.LOGIN})
        //             },
        //             onCloseHandler: () => {
        //                 closeToaster();
        //                 hideBackdropPreloader();
        //             }
        //         })
        //     }
        // }
    }

    const onRegClick = (did, id) => {
        // showBackdropPreloader()
        // redirect to telegram bot
        if ((userState?.user && !isEmptyObj(userState.user)) || getTelegramUserId()) {

            if (content.qr_code_entrance && content.payment === 'paid') {
                openPaymentPopup()
            }
            else {
                showBackdropPreloader()
                registerGuest(city, did, id)
                    .then(() => {
                        // add preloader
                        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START})
                    })
                    .catch(e => {
                        // console.log(e)
                        // e.message || 
                        // TODO: not show errors
                        showNotify({text: "Сталася помилка при реєстрації на подію"})
                        hideBackdropPreloader()
                    })
            }
        }
        // else if (getTelegramUserId()) {
        //     const city = getClientCity(window) || DEFAULT_CITY;
        //     const app = window?.Telegram?.WebApp;
        //     if (app) app.close();
        //     window.open(`https://t.me/MiyProstirBot?start=event-reg-${city}-${did}`)
        // }
        else {
            userDispatch({type: USER_ACTIONS.LOGIN, data: 'Щоб зареєструватись, вам необхідно увійти в систему'})
        }

        // quick accounts folder? or use regular flow ?
            // source: 'telegram'

        // add button quick reqistration for telegram
            // you already has account attached to this telegram id on email
                // its yours? yes - input password
                // no - clear db and create new account

            // informer
                // if exist in DB this tid - ?? that yours account ?

            // add data
                // - email - to have access on web - add your email
                // - instagram - for validation and promo

                // - set password for security and access from web

                // - gender
    }

    // const setPrice = (e) => {
    //     const config = content.priceAndPayments.find(i => i.type == e.newValue)
    //     setRegPrice(config?.price + getCurrency(config?.type))
    // }

    const afterBuyTicketSubmit = () => new Promise(async resolve => {
        // TODO: fix
        // setTimeout(() => {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
            closePaymentPopup();
            resolve();
        // }, 1000)
    })

    if (eventInPast) {
        return <div className='attendedButton'>
                    Подія вже відбулась
                </div>
    }

    if (meta?.tickets?.order?.length > 0) {
        return <>
                {meta.tickets.order.length > 1 && <div className='ticketsListTitle'>Ваші квитки:</div>}
                {meta.tickets.order.map((id) => {
                    const ticket = meta.tickets.list[id];
                    return <div className='eventTicket'>
                        <div className='ticket'>
                            {content.qr_code_entrance && meta.tickets.order.length === 1 && <div className='ticketsListTitle'>Ваш квиток:</div>}
                            {!content.qr_code_entrance && meta.tickets.order.length === 1 && <div className='ticketsListTitle'>Ваша реєстрація:</div>}

                            {ticket.canceled && <div className='canceled'>❌ було скасовано</div>}
                            {ticket.attended && <div className='used'>✅ успішно використано</div>}

                            {content.qr_code_entrance && !ticket.canceled && !ticket.attended && <QRCode
                                size={256}
                                value={`https://t.me/MiyProstirBot?start=event-attend-${id}-${city}-${content._did}`}
                                viewBox={`0 0 256 256`}
                                className="qrcode"
                            />}

                            {ticket?.guests > 1 && <div className='guestsAmount'>{ticket.guests} гостей</div>}

                            {content?.place && !ticket.canceled && !ticket.attended && <div className='location'>
                                📍 Місце проведення:<br /> <a href={`https://maps.google.com/?q=${content.place.lat},${content.place.lng}`} target='_blank'>{content?.place?.title}</a>
                            </div>}

                            {content.route && meta?.tickets?.order?.length > 0 && <Grid item xs={12}>
                                <span className='route labelWrap labelWrapRow'>
                                    <span className="label">Як потрапити:</span>
                                    <span className='labelValue'>
                                        <CKEditorContent
                                            // showSkeleton={contentLoading}
                                            content={content.route}
                                        />
                                    </span>
                                </span>
                            </Grid>}

                            <div className='id'>
                                <span className='code' onClick={() => showTicket(ticket.id)}>
                                    #{id}
                                    <InfoOutlinedIcon />
                                </span>
                                {ticketInfo[ticket.id] && <div className='information'>
                                    {content.qr_code_entrance && <div className="title">Придбано:</div>}
                                    {!content.qr_code_entrance && <div className="title">Зареєстровано:</div>}
                                    <div className="date">{getFormatedTime(timestampToDate(ticket._timestamp), timeZone)}</div>
                                    <Guest guest={ticket} />
                                </div>}
                            </div>
                            {/* <div  className='info'>
                                 <span className='pseudoLink text'>Детальніше</span>
                            </div> */}

                            {/* <div>Імя</div> */}

                            {/* {ticket.pid && <div>Придбано: {prostir_user} {ticket.tid && <>({telegram_user})</>}</div>}
                            {!ticket.pid && ticket.tid && <div>Придбано: {telegram_user}</div>} */}


                            {content.payment !== 'paid' && <div className="actions">                                
                                {!ticket.canceled && <Button
                                    size='small'
                                    fullWidth
                                    target="_blank"
                                    startIcon={<CloseIcon />}
                                    variant="outlined"
                                    onClick={() => onUnRegClick(content._did, ticket.id)}
                                    
                                    // href={`https://t.me/MiyProstirBot?start=event-reg-${city}-${content._did}`}
                                >
                                    Скасувати
                                </Button>}

                                {ticket.canceled && <Button
                                    size='small'
                                    fullWidth
                                    target="_blank"
                                    startIcon={<TelegramIcon />}
                                    variant="outlined"
                                    onClick={() => onRegClick(content._did, ticket.id)}
                                    // href={`https://t.me/MiyProstirBot?start=event-reg-${city}-${content._did}`}
                                    >
                                    Відновити квиток
                                </Button>}
                            </div>}
                        </div>
                    </div>
                })}
            </>
    }

    if (content.registration_button && !meta?.tickets?.order?.length) {
        return <div className='registrationButton'>
                <Button
                        fullWidth
                        target="_blank"
                        variant="outlined"
                        onClick={() => {
                            // if (content.guestsLimits && meta?.guests?.amount >= content.guestsLimits) {
                            //     showNotify({text: "Вибачте, але всі місця на цю подію вже зайняті"});
                            //     return;
                            // }
                            onRegClick(content._did);
                        }}
                        disabled={content.guestsLimits ? (meta?.guests?.amount >= content.guestsLimits) : false}
                    >
                    <div className='text'><HowToRegIcon /> <span>Зареєструватись</span></div>
                    {content.guestsLimits && meta?.guests?.amount >= content.guestsLimits && <div className='full'>Місця закінчились</div>}
                </Button>

                <AdaptiveDialog open={paymentOpen} onClose={closePaymentPopup} title={`Отримати квиток`}>
                    <div className='EventPaymentPopup'>
                        {/* <div className='step'>1) Зробіть донат на 100 000 IDR</div>
                        <div className='wrap'>
                            <p className='payments'>Методи оплати:</p>
                            <p className='payment'>IDR - Permata</p>
                            <p className='payment'>UAH - link</p>
                            <p className='payment'>USDT - крипта</p>

                            <div className='disclaimer'>
                                <p>‼️ кожне місце сплачується окремо</p>
                                <p>💵 Готівка на місці не приймається</p>
                            </div>
                        </div>

                        <div className='step'>2) Завантажте сркіншот про сплату</div>
                        <div className='wrap'>
                        </div> */}

                        <FormContainer
                            notSaveToStorage={true}
                            config={eventBuyTicketConfig}
                            // onChange={onBuyTicketFormChange}
                            afterSubmit={afterBuyTicketSubmit}
                        />

                        {/* <div className='disclaimer'>
                            <p>📍 локацію ви отримаєте одразу після реєстрації. Подія пройде в <FilterChip value={content?.region} config={form?.fields?.region} className="textOnly" /></p>
                            <p>💵 готівка та сплата на місці не приймається</p>
                        </div> */}

                        {/* Показати по фіналу */}
                        {/* <p className='step'>3) очікувати на підтвердження сплати</p>
                        <p>Вам в бот прийде локація та QR код для входу</p>
                        <p>З питань підтримки пишіть на @miy_prostir</p> */}
                    </div>
                </AdaptiveDialog>
            </div>
        }
}

function EventAdminActions(props) {
    const {content, meta} = props
    
    const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()

    const {showNotify} = useNotifyStore();

    const {configs} = useConfigStore();

    const [timeZone, setTimeZone] = useState();
    const [eventInPast, setIventInPast] = useState(false)
    // const [eventLastInfo, setEventLastInfo] = useState(false)
    const [mailingOpen, setMailingOpen] = useState(false);
    const [raffleWindowOpened, setRaffleWindowOpened] = useState(false);
    const [repostPopupOpen, setRepostPopupOpen] = useState(false);
    const [postPopupOpen, setPostPopupOpen] = useState(false);

    // nodeDispatch
    const {userState, nodeDispatch} = useGlobalCustomContext();
    const [telegram] = useState(getTelegramUser());

    const [mailingFormConfig, setMailingFormConfig] = useState()
    const [publishFormConfig, setPublishFormConfig] = useState()
    const [repostFormConfig, setRepostFormConfig] = useState()
    
    const [guestsList, setGuestsList] = useState(null)

    const [publishedDetails, setPublishedDetails] = useState(false);

    const [lastRepostLessThenDayAgo, setLastRepostLessThenDayAgo] = useState();
    const [nextRepostAfter, setNextRepostAfter] = useState();

    const city = getClientCity(window) || DEFAULT_CITY;

    useEffect(() => {
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    useEffect(() => {
        // if (meta?.log_inform?.order?.length > 0) {
            // const lastInformID = meta.log_inform.order[0];
            // setEventLastInfo(dayjs().diff(dayjs(timestampToDate(meta.log_inform.list[lastInformID]._timestamp)), "day"))
        // }
        if (content.date) setIventInPast(dayjs().isAfter(dayjs(timestampToDate(content.date)).add(content.duration, 'hour')))

        const config = {
            fields: {
                type: {
                    type: "filter",
                    placeholder: "Користувачі",
                    required: true,
                    values: {}
                },
                message: {
                    placeholder: "Текст повідомлення для гостей",
                    type: 'textarea',
                    required: true,
                },
                related: {
                    placeholder: "Привязати афішу та посилання на подію до повідомлення",
                    type: "checkbox",
                    default: 'true',
                },
                event: {
                    placeholder: "Привязати до події за її DID",
                    type: "text",
                    visible: {
                        related: "=false"
                    },
                }
            },
            fieldsOrder: [
                "type",
                "message",
                "related",
                "event"
            ],
            form: {
                endpoint: `/bot/prostir/node/event/${city}/${content._did}/inform`,
                submitText: "Відправити",
            }
        }

        if (eventInPast) {
            config.fields.type.values.values = {
                // notinformed: "Гості що не отримували сповіщення",
                attending: "Гості що відвідали подію",
            }
            config.fields.type.values.order = [
                "attending",
            ]
        }
        else {
            config.fields.type.values.values = {
                // notinformed: "Гості що не отримували сповіщення",
                registered: "Зареєстровані",
                myevents: "Гості з 10 останніх подій автора",
                sametype: "Гості з 10 останніх схожих по типу події",
            }
            config.fields.type.values.values.registered += ` (${meta?.guests?.amount}) гостей`

            config.fields.type.values.order = [
                "registered",
                "sametype",
                "myevents"
            ]
        }

        setMailingFormConfig(config)

        setPublishFormConfig(getPublishEventFormConfig(content, meta, true))

        setRepostFormConfig(getPublishEventFormConfig(content, meta, false))
    }, [content])

    useEffect(() => {
        if (meta?.log_posts?.reposted) {
            const lastRepostID = meta.log_posts.reposted.order[0];
            const lastRepost = meta.log_posts.reposted.list[lastRepostID];

            const lastRepostDate = timestampToDate(lastRepost._timestamp);
            setLastRepostLessThenDayAgo(dayjs().diff(dayjs(lastRepostDate), "day") < 2);

            setNextRepostAfter(getFormatedTime(dayjs(lastRepostDate).add(2, 'day'), timeZone));
        }
    }, [meta])

    const onPublishedDetailsToggle = () => {
        setPublishedDetails(!publishedDetails)
    }

    const mailingListOpen = () => {
        setMailingOpen(true)
    }

    const mailingListClose = () => {
        setMailingOpen(false);
    }

    const afterMailingFormSubmit = (result) => new Promise(async resolve => {
        let errors = []
        let success = []
        let inform = ""
        if (result?.result?.errors) {
            errors = result.result.errors;
        }

        if (result?.result?.success) {
            success = result.result.success;
        }

        if (success.length > 0) {
            inform = 'Успішно проінформовано ' + success.length + ' гостей'
        }

        if (errors.length > 0) {
            if (inform.length > 0) inform += ". "
            inform += 'Для ' + errors.length + ' гостей повідомлення не доставлено'
        }

        showNotify({text: inform});
        mailingListClose();

        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});

        resolve();
    })

    // result
    const afterPublishFormSubmit = () => new Promise(async resolve => {
        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
        closePostPopup();
        resolve();
    })

    const afterRepostFormSubmit = () => new Promise(async resolve => {
        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
        closeRepostPopup();
        resolve();
    })

    const guestList = async () => {
        showBackdropPreloader()
        const data = await getGuestList(city, content._did)
        hideBackdropPreloader()
        setGuestsList(data)
    }

    const guestListClose = () => {
        setGuestsList(null)
    }

    const [winner, setWinner] = useState(null)
    const [tickets, setTickets] = useState(null)
    const [winnerIndex, setWinnerIndex] = useState(null)

    const raffleStart = async () => {
        showBackdropPreloader()
        const data = await startRaffle(city, content._did)
        hideBackdropPreloader()
        setWinner(data?.winner)
        setTickets(data?.tickets)
        setWinnerIndex(data?.winnerIndex)
    }

    const raffleWindowOpen = () => {
        setRaffleWindowOpened(true)
    }

    const raffleWindowClose = () => {
        setRaffleWindowOpened(false)
    }

    const raffleClose = () => {
        setWinner(null)
        setWinnerIndex(null)
        setTickets(null)
    }

    const openPostPopup = () => {
        setPostPopupOpen(true)
    }

    const closePostPopup = () => {
        setPostPopupOpen(false)
    }

    const openRepostPopup = () => {
        setRepostPopupOpen(true)
    }

    const closeRepostPopup = () => {
        setRepostPopupOpen(false)
    }

    const getInfoLabel = (label) => {
        if (label === "registered") return "Зареєстровані"
        if (label === "attending") return "Відвідали подію"
        if (label === "sametype") return "Гості з 10 останніх схожих по типу події"
        if (label === "myevents") return "Гості з 10 останніх подій автора"
    }

    const removeTicket = (ticket) => {
        showBackdropPreloader()
        removeGuest(city, content._did, ticket)
            .then(() => {
                // TODO: return from server
                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START})

                const updated = {
                    registred: {
                        list: {},
                        order: [],
                        amount: 0
                    },
                    attending: {
                        list: {},
                        order: [],
                        amount: 0
                    }
                }

                guestsList.registred.order.map(i => {
                    if (i !== ticket) {
                        updated.registred.list[i] = {...guestsList.registred.list[i]}
                        updated.registred.order.push(i)
                        updated.registred.amount += (guestsList.registred.list[i]?.guests ? parseInt(guestsList.registred.list[i]?.guests) : 1)
                    }
                })

                guestsList.attending.order.map(i => {
                    updated.attending.list[i] = {...guestsList.attending.list[i]}
                    updated.attending.order.push(i)
                    updated.attending.amount += (guestsList.attending.list[i]?.guests ? parseInt(guestsList.attending.list[i]?.guests) : 1)
                })

                setGuestsList(updated)

                hideBackdropPreloader()
            })        
    }

    return <>
        {!eventInPast && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && (!isEmptyObj(meta?.post_config)) && !meta?.log_posts?.publish && <Grid item xs={12}><div className='mailingListButton'>
                <Button
                        fullWidth
                        target="_blank"
                        startIcon={<TelegramIcon />}
                        variant="outlined"
                        onClick={openPostPopup}
                    >
                    Опублікувати в телеграм
                </Button>
            </div>
            <AdaptiveDialog open={postPopupOpen} onClose={closePostPopup} title={`Опублікувати`}>
                <div className='TelegramPostPreview'>
                    <img className='TelegramPostPreviewPhoto' src={meta.post_config.preview.image} />
                    <pre className='TelegramPostPreviewText' dangerouslySetInnerHTML={{ __html: makeUrlsClickable(meta.post_config.preview.text) }}></pre>
                </div>
                <FormContainer
                    config={publishFormConfig}
                    afterSubmit={afterPublishFormSubmit}
                />
            </AdaptiveDialog>
        </Grid>}

        {!eventInPast && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && (!isEmptyObj(meta?.post_config)) && meta?.log_posts?.publish && <Grid item xs={12} md={12}>
            <div className='mailingListButton'>
                <Button
                        fullWidth
                        target="_blank"
                        startIcon={<ChatBubbleOutlineIcon />}
                        variant="outlined"
                        onClick={openRepostPopup}
                    >
                    Опублікувати повторно
                </Button>
            </div>
            <AdaptiveDialog open={repostPopupOpen} onClose={closeRepostPopup} title={`Опублікувати повторно`}>
                <div className='AdaptiveDialogPublish'>
                     {/* || eventLastInfo < 2 */}
                    {(lastRepostLessThenDayAgo) && <div className='lastRepostLessThenDayAgo'>
                        Пройшло менше двох днів від останьої публікації
                        {nextRepostAfter && nextRepostAfter.length > 0 && <>. Наступна буде доступна з {nextRepostAfter}</>}
                    </div>}

                    <div className="publishedInfo">
                        <div className='publishedInfoTitle' onClick={onPublishedDetailsToggle}>
                            🗂️ Історія публікацій
                            {publishedDetails && <KeyboardArrowUpIcon />}
                            {!publishedDetails && <KeyboardArrowDownIcon />}
                        </div>

                        <Slide in={publishedDetails} mountOnEnter unmountOnExit>
                            <div className='publishedInfoWrapper'>
                                {meta?.log_posts?.publish && <div className='publication'>
                                    {(meta.log_posts.publish?.data?.published?.[0] || meta.log_posts.publish?.data?.posted?.[0]) && <p>
                                        <EventHistoryTitle log={meta.log_posts.publish} prefix="зробив основний пост (" setTimeZone={setTimeZone}/>
                                        <EventHistoryItem chat={meta.log_posts?.publish?.data?.published?.[0]} />)
                                    </p>}

                                    <EventReposts data={meta?.log_posts?.publish?.data} published={meta.log_posts.publish?.data?.published} />
                                </div>}

                                {meta?.log_posts?.reposted?.order?.map(id =>
                                    <div className='reposted'>
                                        <p>
                                            <EventHistoryTitle
                                                log={meta.log_posts.reposted.list[id]}
                                                prefix="зробив повторну публікацію"
                                                setTimeZone={setTimeZone}/>

                                            {meta.log_posts.publish?.data?.published?.[0] && <EventHistoryItem chat={meta.log_posts?.publish?.data?.published?.[0]} />}
                                        </p>
                                        <EventReposts data={meta.log_posts.reposted.list[id].data} published={meta.log_posts.publish?.data?.published} />
                                    </div>
                                )}
                            </div>
                        </Slide>
                    </div>

                    {/* || eventLastInfo < 2 */}
                    {!(lastRepostLessThenDayAgo) && <FormContainer
                        disabled={(lastRepostLessThenDayAgo)}
                        // || eventLastInfo < 2
                        config={repostFormConfig}
                        afterSubmit={afterRepostFormSubmit}
                    />}
                </div>
            </AdaptiveDialog>
        </Grid>}

        {meta?.guests?.amount > 0 && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && <Grid item xs={12}><div className='guestListButton'>
            <Button
                    fullWidth
                    target="_blank"
                    startIcon={<PeopleIcon />}
                    variant="outlined"
                    onClick={guestList}
                >
                Список гостей ({meta?.guests?.amount})
            </Button>
        </div>

        <AdaptiveDialog open={guestsList} onClose={guestListClose} title={`Список гостей`}>
            {guestsList && <div className='eventGuestsList'>
                {guestsList?.registred?.order?.length > 0 && <>
                    <div className="header">Кількість зареєстрованих гостей: {guestsList?.registred?.amount}</div>
                    <ol>
                        {guestsList?.registred?.order?.map((id, i) => <li>
                            <div className='ticket'>
                                {/* Придбано: */}
                                <DateValue value={guestsList.registred.list[id]?._timestamp} />
                                <Guest guest={guestsList.registred.list[id]} prefix={content.qr_code_entrance ? "" : ""} />
                                <div>
                                    {guestsList.registred.list[id]?.guests > 1 && <div>Гостей: {guestsList.registred.list[id].guests}</div>}
                                    <div className='ticket'>Квиток: {id}</div>
                                    <div>
                                        <QRCode
                                            size={120}
                                            value={`https://t.me/MiyProstirBot?start=event-attend-${id}-${city}-${content._did}`}
                                            viewBox={`0 0 256 256`}
                                            className="qrcode"
                                        />
                                    </div>
                                </div>
                                {/* {!isMobile && <Button size="small" startIcon={<CloseIcon />} variant='outlined' onClick={() => removeTicket(id)}>Видалити</Button>} */}
                                <Button className='close' size="small" onClick={() => removeTicket(id)}><CloseIcon /></Button>
                            </div>
                        </li>)}
                    </ol>
                </>}

                {guestsList?.attending?.order?.length > 0 && <>
                    <div className="header">Кількість гостей що прийшли: {guestsList?.attending?.order?.length}</div>
                    <ol>
                        {guestsList?.attending?.order?.map((id, i) => <li>
                            {/* Придбано:  */}
                            <DateValue value={guestsList.registred.list[id]?._timestamp} />
                            <Guest guest={guestsList.attending.list[id]} prefix={content.qr_code_entrance ? "" : ""} />
                            <div>
                                {guestsList.attending.list[id]?.guests > 1 && <div>Гостей: {guestsList.attending.list[id].guests}</div>}
                                <div className='ticket'>Квиток: {id}</div>
                            </div>
                        </li>)}
                    </ol>
                </>}
            </div>}
        </AdaptiveDialog>
    </Grid>}

{meta?.guests?.amount > 0 && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && <Grid item xs={12} md={12}>
        <div className='raffleButton'>
            <Button
                    fullWidth
                    target="_blank"
                    startIcon={<CardGiftcardIcon />}
                    variant="outlined"
                    onClick={raffleWindowOpen}
                >
                Розіграти приз
            </Button>
        </div>
        <AdaptiveDialog open={raffleWindowOpened} onClose={raffleWindowClose} title={`Почати розіграш`}>
            <Button
                fullWidth
                target="_blank"
                // startIcon={<CardGiftcardIcon />}
                variant="outlined"
                onClick={raffleStart}
            >
                Обрати переможця
            </Button>
        </AdaptiveDialog>
        <AdaptiveDialog open={winner} onClose={raffleClose} title={`Переможець`}>
            {winner && <div className='eventWinner'>
                <div className='eventWinnerTitle'>
                    {winner.id}
                </div>
                <div className='eventWinnerDetails'>
                    {winner.first_name && <span className='first'>{winner.first_name}</span>}
                    {winner.last_name && <span className='last'>{winner.last_name}</span>}
                    {winner.username && <a href={`tg://user?id=${winner.id}`} className='username'>(@{winner.username})</a>}
                    {winnerIndex && <div className='winnerIndex'>Користувач придбав {tickets} квитків, переміг номер {winnerIndex}</div>}
                </div>
            </div>}
        </AdaptiveDialog>
    </Grid>}

    {meta?.guests?.amount > 0 && (isAdmin(userState?.user) || isAuthor(content, userState?.user, telegram)) && <Grid item xs={12} md={12}>
        <div className='mailingListButton'>
            <Button
                    fullWidth
                    target="_blank"
                    startIcon={<PhonelinkRingIcon />}
                    variant="outlined"
                    onClick={mailingListOpen}
                    // disabled={eventLastInfo < 2}
                >
                Сповістити учасників
            </Button>
            {/* {eventLastInfo < 2 && <>
                {eventLastInfo == 0 && <div>Сповіщено сьогодні</div>}
                {eventLastInfo == 0 && <div>Сповіщено {eventLastInfo} дні тому</div>}
            </>} */}
            {/* && eventLastInfo < 2 */}
            {meta?.log_inform?.order && <>
                <p>Історія сповіщень:</p>
                <ul>
                    {meta.log_inform.order.map((i) => <li>
                        <div>{getFormatedTime(timestampToDate(meta.log_inform.list[i]._timestamp), timeZone)}</div>
                        <div><small>id: {i}</small></div>

                        <div>
                            Відправлено: {getInfoLabel(meta.log_inform.list[i]?.data?.type)}

                            {meta.log_inform.list[i]?.data?.related === false && <div>
                                {meta.log_inform.list[i]?.data?.event ? <>- привязано до події: <a href={`?goToDid=${city}:${meta.log_inform.list[i].data.event}`} target='_blank'>{meta.log_inform.list[i].data.event}</a></> : <> - не привязано до події</>}
                            </div>}

                            {meta.log_inform.list[i]?.data?.recipients?.success?.length > 0 && <div>
                                <br/> Отримали: {meta.log_inform.list[i].data.recipients.success.length}
                                &nbsp;
                                (
                                    {meta.log_inform.list[i].data.recipients.success.join(", ")}
                                )
                            </div>}

                            {meta.log_inform.list[i]?.data?.recipients?.errors?.length > 0 && <div>
                                <br/> Помилки: {meta.log_inform.list[i].data.recipients.errors.length}
                                &nbsp;
                                (
                                    {meta.log_inform.list[i].data.recipients.errors.map(tid => <>{`tg://user?id=${tid}`}, </>)}
                                )
                            </div>}
                            {meta.log_inform.list[i]?.data?.recipients?.ignored?.length > 0 && <div>
                                <br/> Не отримали, через налаштування: {meta.log_inform.list[i].data.recipients.ignored.length}
                                &nbsp;
                                (
                                    {meta.log_inform.list[i].data.recipients.ignored.join(", ")}
                                )
                            </div>}
                        </div>

                        <div>
                            <br />
                            Повідомлення: <code>{meta.log_inform.list[i]?.data?.message}</code>
                        </div>
                        <br />
                    </li>)}
                </ul>
            </>}
        </div>
        <AdaptiveDialog open={mailingOpen} onClose={mailingListClose} title={`Сповістити учасників`}>
            <FormContainer
                config={mailingFormConfig}
                afterSubmit={afterMailingFormSubmit}
            />
        </AdaptiveDialog>
    </Grid>}
    </>
}

function Guest(props) {
    const city = getClientCity(window) || DEFAULT_CITY;
    const {guest, prefix} = props

    return <div className='eventGuestsListItem'>
        {guest.pid && <div className='prostir'>
            {prefix && <span>{prefix}</span>}
            {guest.prostir_displayName && <span className='name'>{guest.prostir_displayName}</span>}
            {guest.prostir_displayName && guest.prostir_email && <a href={getUrl(getEnvConfig("prod").domain, city, `/profile/${guest.pid}`)} className='email'>({guest.prostir_email})</a>}
            {guest.prostir_displayName && !guest.prostir_email && <a href={getUrl(getEnvConfig("prod").domain, city, `/profile/${guest.pid}`)} className='email'>{guest.prostir_email}</a>}
        </div>}

        {guest.tid && <div className='telegram'>
            {guest.pid && <span className='tglabel'>Telegram:</span>}
            {!guest.pid && prefix && <span>{prefix}</span>}

            {guest.telegram_first_name && <span className='first'>{guest.telegram_first_name}</span>}
            {guest.telegram_last_name && <span className='last'>{guest.telegram_last_name}</span>}

            {guest.telegram_username && <span className='pseudoLink username' onClick={() => goToUser(guest.telegram_username)}>(@{guest.telegram_username})</span>}
            {guest.tid && !guest.telegram_username && <span className='pseudoLink tid'>tg://user?id={guest.tid}</span>}
        </div>}

        {guest?.promocode && <div>Промокод: {guest.promocode}</div>}
        {guest?.options && <div>Опції: {guest.options}</div>}
        {guest?.notes && <div>Коментар: {guest.notes}</div>}
        
        {guest.screenshot && <>
            <TextZoomImage
                label={<Button size="small" variant='outlined'>Скріншот про сплату</Button>}
            >
                <DefaultImage image={guest.screenshot} width="60" zoom />
            </TextZoomImage>
        </>}
    </div>
}

function getPublishEventFormConfig(content, meta, firstPostConfig = true) {
    const city = getClientCity(window) || DEFAULT_CITY;

    const fc = {
        fields: {
            // telegram_description: {
            //     default: content.description,
            //     type: 'wysiwyg',
            //     placeholder: 'Опис анонсу',
            //     required: true,
            //     options: {
            //         maxLength: 1200
            //     },
            // }
        },
        fieldsOrder: [
            // "telegram_description"
        ],
        form: {
            endpoint: firstPostConfig ? `/bot/prostir/node/event/${city}/${content._did}/telegram-publish` : `/bot/prostir/node/event/${city}/${content._did}/telegram-repost` ,
            submitText: "Опублікувати",
        }
    }

    const hasMainPost = meta?.post_config?.publish
    if (firstPostConfig && hasMainPost) {
        fc.fields.main_post_subtitle = {
            type: "subtitle",
            placeholder: "Зробити головну публікацію в:"
        }
        fc.fieldsOrder.push("main_post_subtitle");

        fc.fields.main_post = {
            // type: meta?.log_posts?.publish ? "subtitle" : "checkbox",
            type: "subtitle",
            placeholder: <span className='ChatSelectSubtitle'><EventHistoryItem chat={meta.post_config.publish} /></span>,
        }
        // if (!meta?.log_posts?.publish) fc.fields.main_post.default = 'true'

        fc.fieldsOrder.push("main_post");
    }

    const chats_publish = []
    const chats_repost = []

    if (meta?.post_config?.repost_by_fields) {
        Object.keys(meta?.post_config?.repost_by_fields).map(field => {
            const config = meta.post_config.repost_by_fields[field]
            const isThread = config.title.includes("(") && config.title.includes("(")
            if (config?.publish_instead_repost) {
                if (isThread) chats_publish.unshift({id: field, ...config})
                else chats_publish.push({id: field, ...config})
            }
            else {
                if (isThread) chats_repost.unshift({id: field, ...config})
                else chats_repost.push({id: field, ...config})
            }
        })
    }

    if (meta?.post_config?.repost_common) {
        Object.keys(meta.post_config.repost_common).map(chat => {
            const isThread = meta.post_config.repost_common[chat].title.includes("(") && meta.post_config.repost_common[chat].title.includes("(")
            if (meta.post_config.repost_common[chat]?.publish_instead_repost) {
                if (isThread) {
                    chats_publish.unshift({id: chat, ...meta.post_config.repost_common[chat]})
                }
                else {
                    chats_publish.push({id: chat, ...meta.post_config.repost_common[chat]})
                }
            }
            else {
                if (isThread) {
                    chats_repost.unshift({id: chat, ...meta.post_config.repost_common[chat]})
                }
                else {
                    chats_repost.push({id: chat, ...meta.post_config.repost_common[chat]})
                }
            }
        })
    }

    const hasMainChatToRepost = meta?.chat && hasMainPost
    if (chats_repost.length > 0 || hasMainChatToRepost) {
        if (hasMainPost) {
            fc.fields["repost_subtitle"] = {
                type: "subtitle",
                placeholder: "Репости в:"
            }
            fc.fieldsOrder.push("repost_subtitle")
        }

        if (hasMainChatToRepost) {
            fc.fields.event_chat = {
                placeholder: <span className='ChatSelectSubtitle'><EventHistoryItem chat={meta.chat} /></span>,
                type: "checkbox",
                default: 'false'
            }
            fc.fieldsOrder.push("event_chat")
        }

        chats_repost.map(chat => {
            fc.fields["repost_" + chat.id] = {
                placeholder: <span className='ChatSelectSubtitle'><EventHistoryItem chat={chat} /></span>,
                type: "checkbox",
                default: 'true'
            }
            fc.fieldsOrder.push("repost_" + chat.id)
        })
    }

    const hasMainChatToPost = meta?.chat && !hasMainPost
    if (chats_publish.length > 0 || hasMainChatToPost) {
        if (hasMainPost) {
            fc.fields["post_subtitle"] = {
                type: "subtitle",
                placeholder: "Копії в:"
            }
            fc.fieldsOrder.push("post_subtitle")
        }

        if (hasMainChatToPost) {
            fc.fields.event_chat = {
                placeholder: <span className='ChatSelectSubtitle'><EventHistoryItem chat={meta.chat} /></span>,
                type: "checkbox",
                default: 'false'
            }
            fc.fieldsOrder.push("event_chat")
        }

        chats_publish.map(chat => {
            fc.fields["post_" + chat.id] = {
                placeholder: <span className='ChatSelectSubtitle'><EventHistoryItem chat={chat} /></span>,
                type: "checkbox",
                default: 'true'
            }
            fc.fieldsOrder.push("post_" + chat.id)
        })
    }

    return fc
}

function EventReposts(props) {
    const {data, published} = props

    return <div className='historyActionDetails'>
        {data?.reposted && <>
            <p className='subtitle'>Репости:</p>
            <ul className='list'>
                {data.reposted.map(chat => <li><EventHistoryItem chat={chat} /></li>)}
            </ul>
        </>}

        {data?.posted && <>
            {published?.[0] && <p className='subtitle'>Копії:</p>}
            <ul className='list'>
                {data.posted.map(chat => <li><EventHistoryItem chat={chat} /></li>)}
            </ul>
        </>}
    </div>
}

function EventHistoryItem(props) {
    const {chat} = props
    let link = chat?.link
    if (!chat.link) {
        link = `https://t.me/${(chat.username || String(chat.chat_id).substring(4))}`
        if (chat.thread) link = `https://t.me/${chat.username || String(chat.chat_id).substring(4)}/${chat.thread}`
        if (chat.message_id) link += `/${chat.message_id}`
    }

    return <>
        {chat.icon && <span><Icon icon={chat.icon} /> </span>}
        <a href={link} target='_blank'>{chat.title}</a>
    </>
}

function EventHistoryTitle(props) {
    const {log, prefix, timeZone} = props;

    let User = <></>

    if (log.pid) {
        const city = getClientCity(window) || DEFAULT_CITY;
        User = <a href={getUrl(getEnvConfig("prod").domain, city, `/profile/${log.pid}`)} className='email'>{log.prostir_displayName}</a>
    }
    else if (log.tid) {
        if (log.telegram_username) {
            User = <span className='pseudoLink' onClick={() => goToUser(log.telegram_username)}>
                {log.telegram_username || (log.telegram_first_name + " " + log.telegram_last_name)}
            </span>
        }
        else {
            User = <span className='pseudoLink'>tg://user?id={log.tid}</span>
        }
    }

    return <span>
        {getFormatedTime(timestampToDate(log._timestamp), timeZone)} - {User} {prefix}
    </span>
}

function goToUser(username) {
    // tid
    // console.log(`tg://user?id=${tid}`)
    // console.log(`https://t.me/user?id=${tid}`)
    const app = window?.Telegram?.WebApp;
    if (app) {
        app.close();
        // app.openTelegramLink(`https://t.me/user?id=${tid}`)
        app.openTelegramLink(`https://t.me/${username}`)
    } else {
        window.open(`https://t.me/${username}`, '_blank')
    }
}